// import datepicker from 'js-datepicker'
// import 'js-datepicker/dist/datepicker.min.css';

import { easepick } from '@easepick/bundle';
import { RangePlugin } from '@easepick/range-plugin';
import { LockPlugin } from '@easepick/lock-plugin';

export default el => {
	const select = el.closest('.select');
	const result = select.querySelector('.js-select-results');
	const input = el.parentNode.querySelector('.js-datepicker-input');
	const inputEnd = el.parentNode.querySelector('.js-datepicker-input-end');
	const lang = el.dataset.datepickerLang;
	var today = new Date(); 
	var min = new Date();
	min.setDate(min.getDate() + 2);

	const picker = new easepick.create({
		lang: lang == 'fr' ? 'fr-FR' : 'en-US',
		element: input,
		css: [
		    "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
		    `${window.location.origin}/wp-content/themes/ecla/assets/css/easypick.css`
		],
		zIndex: 10,
		grid: 2,
		calendars: 2,
		inline: true,
		format: "DD/MM/YYYY",

		// RangePlugin: {
		//     elementEnd: inputEnd,
		//     repick: true,
		//     tooltip: false
		// },
		LockPlugin: {
		    minDate: min,
		    minDays: 0
		},
		plugins: [
		    // RangePlugin,
		    LockPlugin
		],
		setup(picker) {
			picker.on('mousemove', evt => {
				const day = evt.target.closest('.day');
				if (!day) return;

				const tooltip = day.querySelector('.tooltip');
				if (!tooltip) return;

				const dayRect = day.getBoundingClientRect();
				const elRect = day.closest('.calendars').getBoundingClientRect();
				const tooltipRect = tooltip.getBoundingClientRect();

				if (tooltipRect.left < elRect.left) {
					tooltip.style.setProperty('--offsetLeft', `${elRect.left - tooltipRect.left + 10}px`);
				}

				if (tooltipRect.right > elRect.right) {
					tooltip.style.setProperty('--offsetLeft', `${elRect.right - tooltipRect.right - 10}px`);
				}
			});
			picker.on('view', (evt) => {
				const { view, date, target } = evt.detail;
				if (view === 'CalendarDay' && !target.classList.contains('init') && date <= min) {
					const span = target.querySelector('.day-price') || document.createElement('span');
					span.className = 'tooltip';
					span.innerHTML = date.toLocaleDateString("fr") == min.toLocaleDateString("fr") ?
						ParamsData.translations.date_min :
							date.toLocaleDateString('fr') < today.toLocaleDateString('fr') ?
								ParamsData.translations.date_before :
								ParamsData.translations.date_more_than_2;

					if (date.toLocaleDateString("fr") == min.toLocaleDateString("fr")) {
						target.classList.add('first-available');						
					}
								
					target.append(span);
					target.classList.add('init');
				}
			});

			picker.on('select', (evt) => {
				result.innerHTML = evt.detail.date.toLocaleDateString(el.dataset.datepickerLang);
				select.classList.remove('invalid');
				select.classList.remove('active');
			});
      }
	})

	// const picker = datepicker(el, {
	// 	alwaysShow: true,
	// 	minDate: min,
	// 	disableYearOverlay: true,
	// 	showAllDates: true,
	// 	// dateSelected: new Date(),
	// 	onSelect: (instance, date) => {
	// 		result.innerHTML = date.toLocaleDateString(el.dataset.datepickerLang);

	// 		input.value = date.toLocaleDateString('fr');
	// 		select.classList.remove('invalid');
	// 		select.classList.remove('active');
	// 	}
	// });

	// picker.show()
};